<div class="card">
    <div class="card-header">
        <h2 class="card-title">Outside Policy Information <span class="badge badge-success">{{status}}</span></h2>
        <div class="actions">
            @if (policyInEffect) {
            <button class="btn btn-warning btn-sm" data-toggle="modal" data-target="#deactivatePersonalPolicyModal">Cancel Policy</button>
            }
            <button class="btn btn-success btn-sm" (click)="save()" [disabled]="information.invalid" id="btn-save-cpi">Save</button>
        </div>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-12">
                <form class="text-dark" [formGroup]="information">
                    @if (personalPolicies && (personalPolicies.length > 0) && (!policyInEffect)) {
                    <div class="form-row">
                        <div class="form-group col-xs-12">
                            <label for="contactId">Existing Personal Policies</label>
                            <select id="contactId" formControlName="contactId" class="form-control form-control-sm text-dark">
                                @for (policy of personalPolicies; track policy.insuranceContactId) {
                                <option [value]="policy.insuranceContactId">{{policy.provider}}</option>
                                }
                            </select>
                        </div>
                    </div>
                    }
                    @else {
                    <div class="form-row">
                        <div class="form-group col">
                            <contact-advanced-search type="autoInsurance" id="autoInsurance-input" [contactIdSaved]="information.get('contactId').value || 0" [contactNameSaved]="information.get('companyName').value || null" (setContactId)="providerChosen($event)" [isDisabled]="policyInEffect"></contact-advanced-search>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-lg-6 col-xs-12">
                            <label for="effectiveDate">Effective Date</label>
                            <input type="date" id="effectiveDate" class="form-control form-control-sm" formControlName="effectiveDate" />
                        </div>
                        <div class="form-group col-lg-6 col-xs-12">
                            <label for="endDate">Expiry Date</label>
                            <input type="date" id="endDate" class="form-control form-control-sm" formControlName="endDate" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col">
                            <label for="policyNumber">Policy Number</label>
                            <input type="text" id="policyNumber" class="form-control form-control-sm" formControlName="policyNumber" />
                        </div>
                    </div>
                    }
                </form>
            </div>
        </div>
    </div>
</div>

<!-- warning modal -->
<div class="modal fade" id="deactivatePersonalPolicyModal" data-backdrop="static" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="dripicons-cross text-danger display-1"></span>
                <h4 class="text-danger w-100 text-center">Cancel</h4>
                <span class="text-dark my-1 text-center">Are you sure you want to cancel this policy?</span>
                <button class="btn btn-danger mt-2" (click)="deactivate()" [disabled]="loading">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    Yes</button>
                <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="btn-close-modal-cancel-insurance">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->